var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.26,
    height: 33.931,
    viewBox: "0 0 80.26 33.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1645",
    "data-name": "Grupo 1645",
    transform: "translate(-203.068 -47.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462",
    transform: "translate(203.068 47.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_548",
    "data-name": "Trazado 548",
    d: "M203.158,78.006l13.625-30.163a.805.805,0,0,1,.762-.493h.448a.8.8,0,0,1,.762.493l13.535,30.163a.791.791,0,0,1-.762,1.165h-1.793a.823.823,0,0,1-.762-.494l-3.316-7.395H209.746l-3.272,7.395a.825.825,0,0,1-.762.494h-1.793A.791.791,0,0,1,203.158,78.006Zm21.289-9.5c-2.2-4.886-4.347-9.815-6.543-14.7h-.358L211,68.5Z",
    transform: "translate(-203.068 -47.35)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_549",
    "data-name": "Trazado 549",
    d: "M261.533,61.2a7.737,7.737,0,0,1,6.409,3.137.877.877,0,0,1-.179,1.255l-.852.717c-.672.628-.9.179-1.3-.179a5.531,5.531,0,0,0-4.123-1.883,6.085,6.085,0,0,0-5.961,6.364c0,3.586,2.554,6.454,5.916,6.454,2.69,0,3.72-1.345,4.751-2.331.538-.538.852-.449,1.345-.09l.492.358a.9.9,0,0,1,.314,1.255,8.035,8.035,0,0,1-6.857,3.765,9.212,9.212,0,0,1-9.187-9.367A9.443,9.443,0,0,1,261.533,61.2Z",
    transform: "translate(-223.615 -53.129)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_550",
    "data-name": "Trazado 550",
    d: "M288.284,60.416H286a.851.851,0,0,1-.851-.851v-.986a.824.824,0,0,1,.851-.851h2.285V52.753a.882.882,0,0,1,.852-.852l1.434-.09a.842.842,0,0,1,.806.852v5.064h5.2a.824.824,0,0,1,.852.851v.986a.851.851,0,0,1-.852.851h-5.2V70.9c0,1.793.448,2.152,1.479,2.152a8.567,8.567,0,0,0,3.272-.986c.672-.359.851-.09,1.076.269l.672,1.12c.313.538.179.807-.314,1.12a11.714,11.714,0,0,1-5.154,1.524c-3.586,0-4.124-2.151-4.124-4.93Z",
    transform: "translate(-237.323 -49.212)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_551",
    "data-name": "Trazado 551",
    d: "M319.119,61.2a9.188,9.188,0,0,1,8.919,9.367c0,5.154-3.944,9.457-8.919,9.457s-8.919-4.3-8.919-9.457A9.189,9.189,0,0,1,319.119,61.2Zm0,15.91c3.272,0,5.827-2.913,5.827-6.543,0-3.541-2.556-6.409-5.827-6.409s-5.827,2.868-5.827,6.409C313.292,74.193,315.847,77.106,319.119,77.106Z",
    transform: "translate(-247.778 -53.129)",
    fill: "#007eff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_552",
    "data-name": "Trazado 552",
    d: "M325.941,103.443h-5.675a1.494,1.494,0,0,1,0-2.988h5.675a1.494,1.494,0,1,1,0,2.988Z",
    transform: "translate(-48.288 -22.163)",
    fill: "#007eff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActoBlue);
export default __webpack_public_path__ + "static/media/acto-blue.ba27f597.svg";
export { ForwardRef as ReactComponent };